import { Component, OnInit, ViewChild } from '@angular/core';
import { paths } from 'src/app/Shared/enums/paths.enum';
import { CommonService } from 'src/app/Shared/services/common_services/common.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DataCommunicationService } from 'src/app/Shared/services/data_service/data-communication.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { LoaderindicatorService } from 'src/app/Shared/services/loaderindicator/loaderindicator.service';
import { TranslateService } from '@ngx-translate/core';
import { AutheticationService } from 'src/app/Shared/services/authentication/authetication.service';
import { first } from 'rxjs/operators';
import { ModalService } from 'src/app/Shared/services';
import { CustomerRegistrationComponent } from 'src/app/Shared/component/customer-registration/customer-registration.component';

declare var gtag;
@Component({
  selector: 'app-mobile-verification',
  templateUrl: './mobile-verification.component.html',
  styleUrls: ['./mobile-verification.component.css']
})
export class MobileVerificationComponent implements OnInit {
  @ViewChild('regComponent') regComponent: CustomerRegistrationComponent;
  public verifyMobileForm: FormGroup;
  IsSubmitted = false;
  dealerName: string;
  currentData: any;
  showError = false;
  param: any;
  dealerImage: any;
  managerName: any;
  dealerWebsite: string;
  AppointmentSource = "";
  SelectedDealerName = "";
  mySiteId = null;
  isDealerFound: boolean = false;
  
  constructor(private commonService: CommonService,
    private dataCommunicationService: DataCommunicationService,
    protected readonly fb: FormBuilder,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private readonly loadingIndicatorService: LoaderindicatorService,
    private translate: TranslateService,
    private autheticationService: AutheticationService,
    private modalService: ModalService
  ) { }

  // convenience getter for easy access to form fields
  get f() { return this.verifyMobileForm.controls; }


  public getAuthenticationToken() {
    this.isDealerFound = false;
    this.autheticationService.login().pipe(first()).subscribe(result => {
      this.loadingIndicatorService.hide();
      this.dataCommunicationService.getDealerImage(this.param)
        .subscribe(result => {
          this.loadingIndicatorService.hide();
          if (result.StatusCode === 1 && result.Data != null) {
            this.isDealerFound = true;
            this.verifyMobileForm.controls.MobileNumber.enable();
            this.dealerImage = 'data:image/jpeg;base64,' + result.Data.DealerImage;
            this.managerName = result.Data.ManagerName;
            this.dealerWebsite = result.Data.Website;
            this.commonService.setLocalStorage('dealerImage', this.dealerImage);
            this.commonService.setLocalStorage('managerName', this.managerName);
            this.commonService.setLocalStorage('dealerDetails', result.Data);
            this.commonService.setLocalStorage("SelectedDealerName",result.Data.DealerName);
            if(this.mySiteId != null && this.mySiteId != ""){
              this.commonService.setLocalStorage("MySiteId",this.mySiteId);
              this.commonService.setLocalStorage("IsMinBilUser",true);
              this.dataCommunicationService.GetMySiteParams(this.mySiteId).subscribe(resp=>{
                if(resp.StatusCode == 1 && resp.Data != null){
                  this.commonService.setLocalStorage('SelectedVehicleLicensePlate', resp.Data.LicensePlate);   
                  this.commonService.setLocalStorage("AppointmentSource",resp.Data.Source);
                  this.commonService.setLocalStorage('SelectedGiftCardId', resp.Data.GiftCardId);
                  this.AppointmentSource = resp.Data.Source;
                  this.verifyMobileForm.patchValue({
                    MobileNumber: resp.Data.Phone
                  })
                  this.commonService.setLocalStorage('dealername', result.Data.Id);
                  this.verifyMobileNumber();
                }
              })
            }
          }else{
            this.commonService.getErrorMessage('Common.CommonText.label.DealerNotFound');
            
          }
        }, error => {
          //this.showError = true;
          this.commonService.getErrorMessage('Common.CommonText.label.DealerNotFound');
          this.loadingIndicatorService.hide();
          this.isDealerFound = false;
        });
    }, error => {
      this.loadingIndicatorService.hide();
    });
  }
  public verifyMobileNumber() {
    this.translate.get('LoaderText.VerifyMobile').subscribe(message => {
      this.loadingIndicatorService.show(message);
    });
    this.IsSubmitted = true;
    if (this.verifyMobileForm.invalid) {
      return;
    }
    this.dataCommunicationService.getCustomerDetailByMobile(this.verifyMobileForm.value.MobileNumber)
      .subscribe(result => {
        if (result.StatusCode === 1) {
          if(result.Data.MobileNo.startsWith('+47')){
            result.Data.MobileNo = result.Data.MobileNo.substring(3);
          }
          this.commonService.setLocalStorage('customerData', result.Data);
          this.PushDataToAnalytics('true');
          if(this.AppointmentSource === 'mysite'){
            this.commonService.NavigatePage(paths.CARLIST);            
          }       
          else{
            this.generateOTP();   
            this.IsSubmitted = false;
          }          
        } else {
          this.IsSubmitted = false;
          this.PushDataToAnalytics('false');
          this.showError = true;
          this.loadingIndicatorService.hide();
        }
      }, error => {
        this.IsSubmitted = false;
        this.PushDataToAnalytics('false');
        this.showError = true;
        // this.commonService.getErrorMessage('LoaderText.MobileNotMatch');
        this.loadingIndicatorService.hide();
      });
  }

  public generateOTP() {
    this.dataCommunicationService.getMobileOTP(this.verifyMobileForm.value.MobileNumber, this.dealerName, 
      this.AppointmentSource).subscribe(result => {
        if (result.StatusCode === 1) {
          this.IsSubmitted = false;
          this.commonService.setLocalStorage('otpguid', result.Data);
          this.commonService.NavigatePage(paths.OTPVERIFICATION);
        } else {
          this.loadingIndicatorService.hide();
          this.commonService.getErrorMessage('LoaderText.AlertMsg');
        }
      });
  }
  public loadMobileForm() {

    this.verifyMobileForm = this.fb.group({
      MobileNumber: [{value:'',disabled: true}, [Validators.required, Validators.maxLength(8), Validators.minLength(8), Validators.pattern('^[0-9]*$')]],
    });
    
  }

  public isNumber(evt) {
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    this.toastrService.clear();
    return true;
  }

  public PushDataToAnalytics(value) {
    gtag('event', 'PhoneValidation', {'so-customer': value});
  }

  public MobileNoChanged() {
    this.showError = false;
  }
  ngOnInit() {
    this.dealerImage = null;
    this.managerName = null;
    this.AppointmentSource = null;
    // console.log(this.activatedRoute.parent.url)
    // this.activatedRoute.parent.url.subscribe((urlPath) => {
    //   const url = urlPath[urlPath.length - 1].path;
    //   console.log(urlPath)
    //   console.log(url)
    // })
    this.dealerName = this.route.snapshot.queryParamMap.get('dealerName');
    this.AppointmentSource = this.route.snapshot.queryParamMap.get('source');
    this.mySiteId = this.route.snapshot.queryParamMap.get('mysite');
    this.SelectedDealerName = this.commonService.getLocalStorageitem("SelectedDealerName");
    this.commonService.clearLocalStorage();
    this.commonService.setLocalStorage("IsMinBilUser",false);
    if(this.AppointmentSource != null && this.AppointmentSource != ""){
      this.commonService.setLocalStorage("AppointmentSource",this.AppointmentSource);
      this.commonService.setLocalStorage("SelectedDealerName",this.SelectedDealerName);
    }
    this.loadMobileForm();  
    if(this.dealerName != undefined && this.dealerName != '' && this.dealerName != null 
    && this.dealerName != 'undefined' && this.dealerName != 'null'){
      this.translate.get('Common.CommonText.label.welcome').subscribe(message =>{ 
        this.loadingIndicatorService.show(message); 
      });  
      this.commonService.setLocalStorage('dealername', this.dealerName);   
      this.commonService.setLocalStorage('DealerAliasName',this.dealerName);
      this.getAuthenticationToken();
      this.param = { DealerName: this.dealerName }
    }
    else{
      this.loadingIndicatorService.hide();
      window.location.href = 'https://www.motorforum.no/verksted/booking/';
    } 
    
    // this.dealerImage = 'data:image/jpeg;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
  }

  back(){
    this.commonService.NavigatePage(paths.DEALERSELECTION);
  }

  public ShowPopup(id) {
    this.isModalOpen = true;
    let mobileNumber = '';
    if(this.f.MobileNumber.value.length == 8){      
      mobileNumber = this.f.MobileNumber.value;
    }
    this.regComponent.loadRegForm(mobileNumber);
    this.modalService.open(id);
  }

  isModalOpen = false;
  public HidePopUp(id) {
    this.isModalOpen = false;
    this.modalService.close(id);
  }


  
}
